module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEwLjkyMiA1LjUxNmgtLjczM2MtLjE2IDAtLjMxLjA3Ni0uNDA1LjIwN0w3LjMyOCA5LjEzIDYuMjE2IDcuNTg2YS41LjUgMCAwIDAtLjQwNS0uMjA4aC0uNzMzYS4xMjUuMTI1IDAgMCAwLS4xMDEuMTk5bDEuOTQ2IDIuN2MuMTk5LjI3Ni42MS4yNzYuODA4IDBsMy4yOS00LjU2M2EuMTI0LjEyNCAwIDAgMC0uMS0uMTk4Wk04IDFhNyA3IDAgMSAwIDAgMTRBNyA3IDAgMCAwIDggMVptMCAxMi44MTNBNS44MTMgNS44MTMgMCAwIDEgOCAyLjE4N2E1LjgxMyA1LjgxMyAwIDAgMSAwIDExLjYyNloiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/success-info.svg
// module id = +rg4
// module chunks = 40